import { AxiosResponse } from 'axios';

import RestAPI from 'components/Common/restApi';

import { SearchResultsList } from '../types';

export default class GlobalSearchApi {
  static getSearchResults(searchTerm: string): Promise<AxiosResponse<SearchResultsList>> {
    return RestAPI.getWithQueryString('/alpha/global_search/search', { search_term: searchTerm });
  }
}
